<template slot-scope="props">
  <div class="animated fadeIn">
    
    <form>
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
             <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-book mr-2'></i><strong>Relatório - Mapa Fiscal</strong>
                </div>
                <small class="text-muted">Configure os filtros para gerar o documento</small>
            </div>


            <!-- Seção 1: Tipo de Relatório -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="tipoRelatorio" description="Selecione o formato dos dados para o relatório." :class="isDark ? 'text-light' : ''">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Filtros Principais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros Principais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Destinatário / Cliente">
                    <cliente-pesquisa 
                      @retornaId="CLIENTE_ID = $event"
                      :idInicial="CLIENTE_ID"
                      label=""
                      place="Todos os clientes (opcional)"
                      labelBotao=""
                      ref="clientePesquisa"
                      idModal="clienteModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="PRODUTO_ID = $event"
                      :idInicial="PRODUTO_ID"
                      label=""
                      place="Todos os produtos (opcional)"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="GRUPO_PRODUTO_ID"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Situação">
                      <b-form-select :plain="true" v-model="situacao.valor" :options="situacao.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Filtros de Notas Fiscais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-file-text mr-2"></i>Filtros de Nota Fiscal</h6>
              <b-row>
                <b-col md="4" sm="6">
                  <b-form-group label="Finalidade">
                      <b-form-select 
                          :plain="true"  
                          v-model="finalidade.valor" 
                          :options="finalidade.opcoes">
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6">
                  <b-form-group label="Destino">
                      <b-form-select :plain="true" v-model="destino.valor" :options="destino.opcoes" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6">
                  <b-form-group label="Entrada / Saída">
                      <b-form-select :plain="true" v-model="entradaSaida.valor" :options="entradaSaida.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 4: CFOP -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-code mr-2"></i>CFOP</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="CFOP">
                    <c-f-o-p-drop-down
                      v-model="CFOP_ID"
                      ref="cfopDropdown"
                      placeholder="Todos os CFOP">
                    </c-f-o-p-drop-down>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Operação do CFOP">
                      <b-form-select :plain="true" v-model="operacaoCfop.valor" :options="operacaoCfop.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 5: Período e Ordenação -->
            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período e Ordenação</h6>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="DT1" :state="DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="DT2" :state="DT2 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Ordenar Por">
                      <b-form-select :plain="true" v-model="ordem.valor" :options="ordem.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <b-button block size="lg" type="button" variant="primary" @click.stop.prevent="imprimir()" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
          
        </b-col>
      </b-row>
    </form>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import CFOPDropDown from '../componentes/dropdown/CFOPDropDown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    ProdutoPesquisa,
    CFOPDropDown,
    GrupoProdutoDropDown,
    CecInputData
  },
  data () {
    return {
      CLIENTE_ID: null,
      PRODUTO_ID: null,
      GRUPO_PRODUTO_ID: null,
      CFOP_ID: null,
      DT1: moment().format('YYYY-MM-DD'),
      DT2: moment().format('YYYY-MM-DD'),
      
      tipoRelatorio: '1',
      
      situacao: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: '0', text: 'CANCELADO' },
          { value: '1', text: 'EM CADASTRO' },
          { value: '2', text: 'FECHADO' }
        ],
        valor: ''
      },
      
      finalidade: {
        opcoes: [
          { value: '0', text: 'TODOS' },
          { value: '1', text: '1 - NF-e normal' },
          { value: '2', text: '2 - NF-e complementar' },
          { value: '3', text: '3 - NF-e de ajuste' },
          { value: '4', text: '4 - Devolução de Mercadoria' }
        ],
        valor: '0'
      },
      
      destino: {
        opcoes: [
          { value: '0', text: 'TODOS' },
          { value: '1', text: '1 - Operação Interna' },
          { value: '2', text: '2 - Operação Interestadual' },
          { value: '3', text: '3 - Operação com o Exterior' }
        ],
        valor: '0'
      },
      
      entradaSaida: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: 'E', text: 'Entrada' },
          { value: 'S', text: 'Saída' }
        ],
        valor: ''
      },
      
      operacaoCfop: {
        opcoes: [
          { value: '0', text: '0 - TODOS' }
        ],
        valor: '0'
      },
      
      ordem: {
        opcoes: [
          { value: '0', text: '0 - Data Emissão' },
          { value: '1', text: '1 - DANFE' }
        ],
        valor: '0'
      }
    }
  },
  
  methods: {
    getLabelFromDropDown (refName, value) {
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    },
    imprimir () {
      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true

      const params = {
        dt1: this.DT1,
        dt2: this.DT2,
        clienteId: this.CLIENTE_ID || '',
        lbCliente: this.$refs.clientePesquisa?.$refs?.auto?.display || '',
        produtoId: this.PRODUTO_ID || '',
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
        lbGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID),
        cfopId: this.CFOP_ID || '',
        lbCfop: this.getLabelFromDropDown('cfopDropdown', this.CFOP_ID),
        situacao: this.situacao.valor,
        finalidade: this.finalidade.valor,
        destino: this.destino.valor,
        entradaSaida: this.entradaSaida.valor,
        operacaoCfop: this.operacaoCfop.valor,
        ordem: this.ordem.valor,
        lbEmpresa: window.localStorage.getItem('nomeempresa') || '',
        lbUsuario: window.localStorage.getItem('nomeusuario') || '',
        tipoRel: this.tipoRelatorio
      }

      const uri = '/api/protected/relatorios/mapafiscal/analitico?' + new URLSearchParams(params).toString()
        
      this.$http.get(uri, {responseType: 'arraybuffer'})
      .then(response => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast('Relatório Gerado com Sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'relMapaFiscal.pdf') 
        link.download = 'RelMapaFiscal.pdf'
        
        const janela = window.open(link)
        janela.onload = function(){
          setTimeout(() => {
            janela.document.title = 'Relatório - Mapa Fiscal'
          }, 2000);
        }
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(erro => {
        this.$toast.error({
          title: 'Erro',
          message: 'Ocorreram erros ao gerar o Relatório',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        this.$store.commit('controle/setAguardando', false)
      })
    }
  },
  
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    opcoesRelatorio () {
      let opcoes = [
        { value: '1', text: 'Sintético' },
        { value: '2', text: 'Acumulado de Grupos' },
        { value: '3', text: 'Acumulado de Produtos' },
        { value: '4', text: 'Sintético Agrupado por Cliente' }
      ]
      return opcoes
    },

    isValid () {
      return !!this.DT1 && !!this.DT2
    }
  },
  
  created () {
    // Inicialização se necessário
  }
}
</script>

<style scoped>

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ebedef;
  transition: all 0.3s ease;
}

.section-container.dark-mode {
  background: #23282c;
  border-color: #3a4149;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  background: #ffffff;
}

.section-container.dark-mode:hover {
  background: #2f353a;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #63c2de;
}

.select-premium {
  border: 1px solid #20a8d8;
  color: #20a8d8;
  font-weight: 600;
  cursor: pointer;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  transition: transform 0.2s ease;
}

.btn-generate:hover {
  transform: translateY(-2px);
}

hr {
  border-top: 1px solid #ebedef;
}

hr.border-secondary {
  border-color: #3a4149 !important;
}

.form-group label {
  font-weight: 600;
  color: #4f5d73;
  margin-bottom: 0.5rem;
}

.dark-mode .form-group label {
  color: #c8ced3;
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelMapaFiscal.vue